import { render, staticRenderFns } from "./ClvAccountSettings.vue?vue&type=template&id=772b5e0a&"
import script from "./ClvAccountSettings.vue?vue&type=script&lang=js&"
export * from "./ClvAccountSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports